import { Component, OnInit } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomerContactService } from '../../services/customer-contact/customer-contact-service.service';

@Component({
  selector: 'app-submit-quote-dialog',
  templateUrl: './submit-quote-dialog.component.html',
  styleUrls: ['./submit-quote-dialog.component.scss'],
})
export class SubmitQuoteDialogComponent implements OnInit {
  quoteForm: FormGroup;
  customers: any[] = [];
  contacts: any[] = [];

  constructor(
    private fb: FormBuilder,
    public ref: DynamicDialogRef,
    public customerContactService: CustomerContactService
  ) {
    this.quoteForm = this.fb.group({
      mode: ['sandbox', Validators.required],
      customer: [null, this.modeValidator.bind(this)],
      contact: [null, this.modeValidator.bind(this)],
    });
  }

  ngOnInit(): void {
    this.customerContactService.getCustomerDropdown().subscribe(
      (data) => {
        this.customers = data;
        console.log('Customers:', this.customers);
      },
      (error) => {
        console.error('Error fetching customers:', error);
      }
    );

    this.quoteForm?.get('customer')?.valueChanges.subscribe((customer) => {
      if (customer) {
        this.searchContacts(customer);
      }
    });

    this.quoteForm?.get('mode')?.valueChanges.subscribe((mode) => {
      this.updateValidators();
    });
  }

  searchContacts(customer: any) {
    this.customerContactService
      .getContactDropdown(customer?.customer_id)
      .subscribe(
        (data) => {
          this.contacts = data;
        },
        (error) => {
          console.error('Error fetching contacts:', error);
        }
      );
  }

  modeValidator(control: any) {
    const mode = this.quoteForm?.get('mode')?.value;
    if (mode === 'business' && !control.value) {
      return { required: true };
    }
    return null;
  }

  updateValidators() {
    const customerControl = this.quoteForm.get('customer');
    const contactControl = this.quoteForm.get('contact');
    customerControl?.updateValueAndValidity();
    contactControl?.updateValueAndValidity();
  }

  submit() {
    if (this.quoteForm.valid) {
      console.log(this.quoteForm.value);
      this.ref.close(this.quoteForm.value);
    }
  }

  cancel() {
    this.ref.close(null);
  }
}
